<template>
    <div
        class="cursor-pointer text-xl p-2 bg-gray-100 rounded-lg2 text-gray-400 hover:text-gray-900"
    >
        <slot />
    </div>
</template>
